import React from 'react';
import { computeDoudizhuCounterRemaining, DOUDIZHU_COUNTER_RANKS, translateCardData } from '../utils';

function CardCounter({ myHandCards, playedCards }) {
    const remaining = computeDoudizhuCounterRemaining(myHandCards, playedCards);

    return (
        <div className="doudizhu-card-counter">
            <div className="doudizhu-card-counter-row doudizhu-card-counter-row--labels">
                {DOUDIZHU_COUNTER_RANKS.map(({ rank, sample }) => {
                    const [rankClass, suitClass, rankText, suitText] = translateCardData(sample);
                    return (
                        <div key={rank} className="doudizhu-card-counter-cell">
                            <div className={`playingCards card-counter-card card ${rankClass} ${suitClass}`}>
                                <span className="rank">{rankText}</span>
                                {suitText ? <span className="suit">{suitText}</span> : null}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="doudizhu-card-counter-row doudizhu-card-counter-row--counts">
                {DOUDIZHU_COUNTER_RANKS.map(({ rank }) => (
                    <div
                        key={rank}
                        className={`doudizhu-card-counter-cell doudizhu-card-counter-count${
                            remaining[rank] === 0 ? ' is-zero' : ''
                        }`}
                    >
                        {remaining[rank]}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CardCounter;
